import type { ReactNode } from 'react'

import cn from 'classnames'

import LanguageMenu from '../LanguageMenu'

import LogoImage from '@assets/images/banky-logo-black.png'

import './checkoutContainer.scss'

interface CheckoutContainerProps {
  className?: string
  hideLanguage?: boolean
  children: ReactNode
}

const CheckoutContainer = ({ className, hideLanguage = false, children }: CheckoutContainerProps) => (
  <div className={cn('checkout-container-wrapper', className)}>
    <div className='checkout-container-content'>
      <div className='checkout-container-header'>
        <span className='logo'>
          <img src={LogoImage} alt='Logo' />
        </span>
        {hideLanguage ? null : <LanguageMenu />}
      </div>
      {children}
    </div>
  </div>
)

export default CheckoutContainer
